module.exports = __webpack_public_path__ + "static/media/ic_close_dark 2.4101c46c.svg";